import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group',
  templateUrl: './banker-group.component.html',
  styleUrls: ['./banker-group.component.scss']
})
export class BankerGroupComponent implements OnInit {

  public groups:any = [];
  public selected_company:any = null;
  constructor(private http: HttpService) { 
    this.selected_company = this.http.getStaticSelectedCompany();
    this.getList();
  }

  ngOnInit(): void {
  }

  async getList() {
    this.groups = await this.http.post("/admin/banker-group/get");
  }

  async delete(uuid: string) {
    let confirmed = confirm("Are you sure you want to delete this group?");
    if(!confirmed) {
      return;
    }
    const res:any = await this.http.post("/admin/banker-group/delete", {uuid: uuid});
    if(res.status) {
      this.getList();
    }
  }

}
